<template>
  <div class="tracking-list">
    <div class="row">
      <div class="small-12 column">
        <h3 class="title">{{$t('order.label.item.tracking-label')}}</h3>
      </div>
    </div>
    <div class="row">
      <div class="small-5 medium-3 large-2 column">{{$t('order.label.item.tracking.shipped-qty')}}</div>
      <div class="small-7 medium-9 large-10 column"><strong>{{articleShippedQty}}</strong></div>
    </div>
    <div class="row" v-if="!hasTrackingItems">
      <div class="small-12 column">
        <p v-if="!trackingItemsIsDefined">{{$t('order.label.item.tracking.not-available')}}</p> <!-- array undefined -->
        <p v-else>{{$t('order.label.item.tracking.parcel-tracking-nolink')}}</p> <!-- array vide -->
      </div>
    </div>
    <div class="content" v-else>
      <div class="row">
        <div class="small-4 medium-3 large-2 column number">{{$t('order.label.item.tracking.parcel-number')}}</div>
        <div class="small-7 medium-9 large-10 small-offset-1 medium-offset-0 column">{{$t('order.label.item.tracking.parcel-tracking-url')}}</div>
      </div>
      <div class="row" v-for="trackingItem in trackingItems">
        <div class="small-4 medium-3 large-2 column number"><strong>{{trackingItem.number}}</strong></div>
        <div class="small-7 medium-9 large-10 small-offset-1 medium-offset-0 column">
          <delivery-chips :link="trackingItem.link" class="no-margin"></delivery-chips>
        </div>
      </div>
    </div>
    <div class="row" v-if="articleOrderedQty != articleShippedQty">
      <div class="small-5 medium-3 large-2 column">{{$t('order.label.item.remaining-qty')}}</div>
      <div class="small-7 medium-9 large-10 column"><strong>{{articleOrderedQty-articleShippedQty}}</strong></div>
    </div>
  </div>
</template>

<script>
  import DeliveryChips from 'components/DeliveryChips'

  export default {
    name: 'tracking-list',
    props: [
      'tracking-items',
      'article-ordered-qty',
      'article-shipped-qty'
    ],
    components: {
      'delivery-chips': DeliveryChips
    },
    computed: {
      getTrackingItems: function () {
        return this.trackingItems || []
      },
      hasTrackingItems: function () {
        return this.getTrackingItems.length
      },
      trackingItemsIsDefined: function () {
        return typeof this.trackingItems === 'object'
      }
    },
    methods: {
    }
  }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .tracking-list {
    border: 1px solid $somfy;
    padding: 5px 0;
    margin: 17px 0 0px 0;

    h3.title {
      margin: 0 0 10px 0;
      color: $somfy;
      text-transform: uppercase;
    }

    .content {
      font-size: 11px;

      > .row {
        padding: 5px 0
      }

      .number {
        text-align: right;
      }
    }
    .no-margin{
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// TrackingList.vue?549997c2